import { c as _c } from "react/compiler-runtime";
import { FlexCenter, TextHeading } from "@opensea/ui-kit";
import { ChevronLeft } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
export const BackButton = t0 => {
  const $ = _c(8);
  const {
    onClick
  } = t0;
  const t = useTranslations("wallet.BackButton");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ChevronLeft size={30} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("back");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <TextHeading className="font-normal" size="sm">{t2}</TextHeading>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onClick || $[6] !== t3) {
    t4 = <FlexCenter className="gap-0.5 text-text-secondary" onClick={onClick}>{t1}{t3}</FlexCenter>;
    $[5] = onClick;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};